export { default as Spotlight } from './Spotlight';
